import type { QueryKey } from '@tanstack/react-query';

/** Centralized React Query keys for walkthrough (tour guiado) data. */
export const walkthroughKeys = {
  all: ['walkthrough'] as QueryKey,
  list: (filters?: Record<string, unknown>): QueryKey => [
    'walkthrough',
    'list',
    filters ?? {},
  ],
  detail: (id: string): QueryKey => ['walkthrough', 'detail', id],
  myPending: (): QueryKey => ['walkthrough', 'me', 'pending'],
};
